import { ExternalContactsBiddingStatus, InternalContactsBiddingStatus, UserCertifyType } from 'common/constants';
import {
  CreditStrategy,
  PublishWay,
  TaskAttachment,
  TaxSettlementFlag,
  AccountType,
  ArtWorkType,
  WorkStyleType,
  UserTaskRole,
  YLRecommendPriorityEnum,
  StageFinishTime,
  RiskTagsWithName,
  ParentTaskMode,
  ResExampleImage,
} from 'common/types';

export enum ApplyFilterEnum {
  REAL_NAME = 'REAL_NAME', //实名认证
  ARTIST = 'ARTIST', //创作者
  BANK_CARD = 'BANK_CARD', //银行卡
  EMAIL = 'EMAIL', //邮箱
  BANK_ADDR = 'BANK_ADDR', //银行卡开户行
  BANK_REGION = 'BANK_REGION', //银行卡开户行地区
  COMMON_ADDRESS = 'COMMON_ADDRESS', //常用地址
  CONTRACT = 'CONTRACT', //保密协议
  ID_CARD_PHOTO = 'ID_CARD_PHOTO', //身份证照片
  VAT_AGENCY_DECLARATION = 'VAT_AGENCY_DECLARATION', //增值税及附加税费代办申报授权
}

export const ApplyFilterEnumMap = {
  [ApplyFilterEnum.REAL_NAME]: '实名认证',
  [ApplyFilterEnum.ARTIST]: '创作者认证',
  [ApplyFilterEnum.BANK_CARD]: '银行卡绑定',
  [ApplyFilterEnum.EMAIL]: '邮箱绑定',
  [ApplyFilterEnum.CONTRACT]: '签署保密协议',
  [ApplyFilterEnum.COMMON_ADDRESS]: '常用地址',
  [ApplyFilterEnum.BANK_ADDR]: '银行卡开户行',
  [ApplyFilterEnum.BANK_REGION]: '开户行地区',
  [ApplyFilterEnum.ID_CARD_PHOTO]: '身份证照片',
  [ApplyFilterEnum.VAT_AGENCY_DECLARATION]: '增值税及附加税费代办申报授权',
};

export type BidingApplicationForm = {
  quotation: number; // 报价
  description: string;
  attachment: any[];
};
export type Applicant = {
  nickName: string;
  uniqueId: number;
  preview: string; //旧数据
  avatar?: string; //明确头像信息
  tag: UserCertifyType;
  personalProfile?: string;
  taxRate?: string;
  userCertifyType?: UserCertifyType;
  recommendDesc?: string;
  mediaUserId?: number;
  avgScore?: string;
  mediaNickname?: string;
  userCode?: string;
  priority?: YLRecommendPriorityEnum;
};

// 申请需求的信息
export type BidingApplication = BidingApplicationForm & {
  uniqueId: number;
  applicant: Applicant;
  status: ExternalContactsBiddingStatus;
  createTime: string;
  allocator?: AccountType;
  credit: string;
  artwork: ArtWorkType[];
  quotation: string;
  planFinishTime?: string; //预计交稿时间
  isYLRecommend?: boolean;
  stageFinishTime?: StageFinishTime[]; // 阶段预期交稿时间信息

  quotedPrice?: string;
  calendar?: string;
  priority?: YLRecommendPriorityEnum;
  recommendSource: 'media' | 'tiangong';
  riskTag?: {
    personal?: RiskTagsWithName;
    enterprise?: RiskTagsWithName;
  };
  canChangeQuotation?: boolean; // 是否可修改报价，默认 false
};

export type StageTemplate = {
  id: number;
  stage: string;
  template: any[];
};

export type BiddingTask = {
  createTime?: string;
  parentTaskId?: number; //已确认的需求，关联的父需求
  uniqueId: number; // 标识
  taskSubject: string; // 名称
  preview?: string; // 缩略图
  agreement?: {
    // 额外协议
    name: string;
    url: string;
  };
  allocator?: AccountType;
  externalContacts: string[]; // 制作方接口人
  internalContacts: string[]; // 内部接口人
  watchers?: string[]; // 观察者
  endTime?: string; // 结束时间
  planFinishTime?: string; // 预计结束时间
  publishWay: PublishWay; // 发布方式
  userTag: UserCertifyType; // 企业/个人
  remainingTime?: string; // 倒计时，秒
  hrDays?: number; // 预估人天
  popoId?: string; // 对应 popo 群聊
  attachment?: TaskAttachment[]; // 需求附件
  description?: string;
  stagePassNum: number; // 当前进度
  stageTotal: number; // 总步骤
  creditStrategy: CreditStrategy; // 价格策略
  requirementType?: string;
  applyNum: number; // 竞标人数
  credit: string;
  applyList?: {
    items: BidingApplication[];
  };
  status: ExternalContactsBiddingStatus;
  requirementSource: UserCertifyType;

  stageFinishTime: StageFinishTime[];
  stageTemplateList: StageTemplate[];

  currentUserBiddenId?: number;
  applyFileSizeLimit: number;
  allocatorSettlementCommission?: string;
  taxSettlementFlag: TaxSettlementFlag;

  exampleImages?: ResExampleImage[];
  styleList?: WorkStyleType[];
  recommendFileType?: string[];
  role?: UserTaskRole[];

  isDelete?: boolean; // 是否已经删除
  isSigned?: boolean; //是否签署保密协议
  isRequireContract?: boolean; // 是否保密
  contractPreview?: string; //保密协议
  contractId?: number;
  contractTemplateId?: number;
  contractName?: string;
  applyFilter?: ApplyFilterEnum[]; //应征的条件
  isSecret: boolean; // 是否加密需求
  taskMode: ParentTaskMode; // 需求模式
  userRate?: string; // 企业用户服务费率
};

export enum UserQueryKey {
  NickName = 'nickName',
  Phone = 'phone',
  Email = 'email',
  Id = 'id',
}

export type BiddingQueryParams = {
  biddenStatus?: InternalContactsBiddingStatus | 'ALL';
  projectId?: string;
  account?: Array<UserQueryKey | string>;
  createTime?: string[];
  isDelete?: boolean | 'ALL';
  sourceUniqueId?: string;
};

export type InviteMineBiddingTask = {
  biddenId: number;
  taskSubject: string;
  credit: string;
  preview: string;
  isRequireContract: boolean;
  isSigned: boolean;
  parentTaskId: number;
};

export enum InviteSource {
  ALGO = 1,
  NOT_ALGO = 2,
}

export type RecommendNumOverview = {
  total?: number;
  needYLRecommendNum?: number;
  unRecommendNum?: number;
  unInvitedNum?: number;
  noBiddenNum?: number;
  biddingNum?: number;
};
